module.exports = __webpack_public_path__ + "img/ponte-sud_ovest.eac58cde.png";